var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viewer"},[_c('div',{ref:"container",staticClass:"viewer"}),_c('ViewportOverlay',_vm._b({},'ViewportOverlay',_vm.dataDetails,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }